"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EchoBus = exports.WebSocketBus = exports.createServerCall = exports.createServerHandler = exports.createClientCall = void 0;
var utils_1 = require("./utils");
var types_1 = require("./types");
function makeRequestMsg(type, requestID, data) {
    return {
        apiName: 'VTubeStudioPublicAPI',
        apiVersion: '1.0',
        messageType: type + "Request",
        requestID: requestID,
        data: data,
    };
}
function makeResponseMsg(type, requestID, data) {
    return {
        apiName: 'VTubeStudioPublicAPI',
        apiVersion: '1.0',
        timestamp: Date.now(),
        messageType: type + "Response",
        requestID: requestID,
        data: data,
    };
}
function makeErrorMsg(requestID, data) {
    return {
        apiName: 'VTubeStudioPublicAPI',
        apiVersion: '1.0',
        timestamp: Date.now(),
        messageType: 'APIError',
        requestID: requestID,
        data: data,
    };
}
function msgIsRequest(msg, type) {
    return msg.messageType === type + "Request";
}
function msgIsResponse(msg, type) {
    return msg.messageType === type + "Response";
}
function msgIsError(msg) {
    return msg.messageType === 'APIError';
}
function createClientCall(bus, type, defaultTimeout) {
    if (defaultTimeout === void 0) { defaultTimeout = 5000; }
    return (function (data, config) { return new Promise(function (resolve, reject) {
        var _a;
        var requestID = utils_1.generateID(16);
        var handler = function (msg) {
            var _a, _b;
            if (msg.requestID === requestID) {
                bus.off(handler);
                clearTimeout(handler.context.timeout);
                if (msgIsResponse(msg, type))
                    resolve((_a = msg.data) !== null && _a !== void 0 ? _a : {});
                else if (msgIsError(msg))
                    reject(new types_1.VTubeStudioError((_b = msg.data) !== null && _b !== void 0 ? _b : {}, requestID));
            }
        };
        handler.context = {
            timeout: setTimeout(function () {
                bus.off(handler);
                reject(new types_1.VTubeStudioError({ errorID: types_1.ErrorCode.InternalClientError, message: 'The request timed out.' }, requestID));
            }, (_a = config === null || config === void 0 ? void 0 : config.timeout) !== null && _a !== void 0 ? _a : defaultTimeout),
            reject: reject,
            requestID: requestID,
        };
        bus.on(handler);
        bus.send(makeRequestMsg(type, requestID, data !== null && data !== void 0 ? data : {}));
    }); });
}
exports.createClientCall = createClientCall;
function createServerHandler(bus, type, handler) {
    var _this = this;
    return function (msg) { return __awaiter(_this, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!msgIsRequest(msg, type)) return [3, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4, handler(msg.data)];
                case 2:
                    response = _a.sent();
                    bus.send(makeResponseMsg(type, msg.requestID, response));
                    return [3, 4];
                case 3:
                    e_1 = _a.sent();
                    if (e_1 instanceof types_1.VTubeStudioError) {
                        bus.send(makeErrorMsg(msg.requestID, e_1.data));
                    }
                    else {
                        bus.send(makeErrorMsg(msg.requestID, { errorID: types_1.ErrorCode.InternalClientError, message: String(e_1) }));
                    }
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
}
exports.createServerHandler = createServerHandler;
function createServerCall(bus, type, handler) {
    var h = createServerHandler(bus, type, handler);
    bus.on(h);
    return handler;
}
exports.createServerCall = createServerCall;
var MessageBusBase = (function () {
    function MessageBusBase() {
        this.handlers = [];
    }
    MessageBusBase.prototype.on = function (handler) {
        this.handlers.push(handler);
    };
    MessageBusBase.prototype.off = function (handler) {
        this.handlers.splice(this.handlers.findIndex(function (h) { return h === handler; }), 1);
    };
    MessageBusBase.prototype.receive = function (msg) {
        for (var _i = 0, _a = __spreadArray([], this.handlers); _i < _a.length; _i++) {
            var handler = _a[_i];
            handler(msg);
        }
    };
    return MessageBusBase;
}());
var WebSocketBus = (function (_super) {
    __extends(WebSocketBus, _super);
    function WebSocketBus(webSocket) {
        var _this = _super.call(this) || this;
        _this.webSocket = webSocket;
        _this.isClosed = false;
        webSocket.addEventListener('message', function (e) {
            var msg = JSON.parse(e.data);
            _this.receive(msg);
        });
        webSocket.addEventListener('close', function () {
            _this.close();
        });
        webSocket.addEventListener('error', function (e) {
            _this.throwException(function (requestID) { return new types_1.VTubeStudioError({ errorID: types_1.ErrorCode.MessageBusError, message: "Message bus error: " + e }, requestID, e); });
        });
        return _this;
    }
    WebSocketBus.prototype.on = function (handler) {
        if (this.isClosed)
            return;
        return _super.prototype.on.call(this, handler);
    };
    WebSocketBus.prototype.off = function (handler) {
        if (this.isClosed)
            return;
        return _super.prototype.off.call(this, handler);
    };
    WebSocketBus.prototype.receive = function (msg) {
        if (this.isClosed)
            return;
        return _super.prototype.receive.call(this, msg);
    };
    WebSocketBus.prototype.send = function (msg) {
        if (this.isClosed)
            return;
        this.webSocket.send(JSON.stringify(msg));
    };
    WebSocketBus.prototype.close = function () {
        this.throwException(function (requestID) { return new types_1.VTubeStudioError({ errorID: types_1.ErrorCode.MessageBusClosed, message: 'Message bus closed.' }, requestID); });
        this.isClosed = true;
    };
    WebSocketBus.prototype.throwException = function (errorSupplier) {
        for (var _i = 0, _a = __spreadArray([], this.handlers); _i < _a.length; _i++) {
            var handler = _a[_i];
            if (handler.context !== undefined) {
                clearTimeout(handler.context.timeout);
                handler.context.reject(errorSupplier(handler.context.requestID));
            }
        }
        this.handlers = [];
    };
    return WebSocketBus;
}(MessageBusBase));
exports.WebSocketBus = WebSocketBus;
var EchoBus = (function (_super) {
    __extends(EchoBus, _super);
    function EchoBus(otherBus) {
        var _this = _super.call(this) || this;
        if (otherBus)
            _this.other = otherBus;
        else
            _this.other = new EchoBus(_this);
        return _this;
    }
    EchoBus.createLinkedPair = function () {
        var clientBus = new EchoBus();
        var serverBus = clientBus.other;
        return { clientBus: clientBus, serverBus: serverBus };
    };
    EchoBus.prototype.send = function (msg) {
        this.other.receive(msg);
    };
    return EchoBus;
}(MessageBusBase));
exports.EchoBus = EchoBus;
